var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "브릿지"
    },
    scopedSlots: _vm._u([{
      key: "contents",
      fn: function fn() {
        return [_c('expo-program-list-filter', _vm._b({
          staticClass: "mb-20 mb-lg-40"
        }, 'expo-program-list-filter', {
          loading: _vm.loading
        }, false)), _vm.items.length ? [_c('div', {
          staticClass: "v-cards"
        }, [_vm._l(_vm.items, function (item) {
          return [_c('expo-program-item', {
            key: item._id,
            attrs: {
              "value": item
            },
            scopedSlots: _vm._u([{
              key: "actions",
              fn: function fn() {
                return [_c('v-row', {
                  staticClass: "ma-n4"
                }, [_c('v-col', {
                  staticClass: "pa-4",
                  attrs: {
                    "cols": "auto"
                  }
                }, [_c('expo-employee-form', _vm._b({
                  on: {
                    "input": _vm.updateItem_employee
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function fn(_ref) {
                      var attrs = _ref.attrs,
                        on = _ref.on;
                      return [_c('v-btn', _vm._g(_vm._b({
                        staticClass: "min-w-80px min-w-lg-120px",
                        attrs: {
                          "small": "",
                          "color": "primary"
                        }
                      }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 지원정보 수정 ")])])];
                    }
                  }], null, true),
                  model: {
                    value: item.employee,
                    callback: function callback($$v) {
                      _vm.$set(item, "employee", $$v);
                    },
                    expression: "item.employee"
                  }
                }, 'expo-employee-form', {
                  program: item
                }, false))], 1), _c('v-col', {
                  staticClass: "pa-4",
                  attrs: {
                    "cols": "auto"
                  }
                }, [_c('expo-employee-remove', _vm._g(_vm._b({
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function fn(_ref2) {
                      var attrs = _ref2.attrs,
                        on = _ref2.on;
                      return [_c('v-btn', _vm._g(_vm._b({
                        staticClass: "min-w-80px min-w-lg-120px",
                        attrs: {
                          "small": "",
                          "outlined": "",
                          "color": "grey-d"
                        }
                      }, 'v-btn', attrs, false), on), [_c('span', {
                        staticClass: "grey-6--text"
                      }, [_vm._v(" 신청취소 ")])])];
                    }
                  }], null, true)
                }, 'expo-employee-remove', {
                  value: item
                }, false), {
                  search: _vm.search
                }))], 1)], 1)];
              },
              proxy: true
            }], null, true)
          })];
        })], 2), _c('v-pagination', {
          attrs: {
            "value": _vm.page,
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: Object.assign({}, _vm.$route.query, {
                  page: page
                })
              });
            }
          }
        })] : [_c('v-layout', {
          staticClass: "w-100 grey-f7 rounded-lg pa-20",
          style: _vm.innerWidth < 1024 ? {
            height: 'calc(100vh - 367px)'
          } : {
            height: 'calc(100vh - 472px)'
          },
          attrs: {
            "column": "",
            "justify-center": "",
            "align-center": ""
          }
        }, [_c('p', {
          staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
        }, [_vm._v(" 안녕하세요, 회원님. "), _c('br'), _vm._v(" 참여중인 프로그램이 없습니다. ")]), _c('v-btn', {
          staticClass: "v-btn--column",
          attrs: {
            "text": "",
            "height": "auto",
            "color": "transparent",
            "href": "/programs"
          }
        }, [_c('i', {
          staticClass: "icon icon-plus-lg"
        }), _c('span', {
          staticClass: "mt-6 mt-lg-14 grey-9--text"
        }, [_vm._v("프로그램 참여하기")])])], 1)]];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }